<template lang="pug">
  el-card.box(shadow="hover")
    h1 Clientes do WhatsApp
    div.containerBotao
      span Clientes registrados
      el-button.botaoAdd(type="primary", icon="el-icon-plus", id='botao-add', @click="registrarCliente") Registrar Cliente
    div.modulosContainer
      div.modulo(v-for="cliente in clientes" :key="cliente.clientId")
        el-row(type="flex", justify="space-between").nomeModuloContainer
          span.titulo
            h3 {{ encurtarString(cliente.clientId.length, 15, cliente.clientId) }}
          el-dropdown(trigger="click")
            el-col(:span="2")
              i.fa.fa-ellipsis-v(:style="{'font-size': '22px','cursor': 'pointer'}")
              template#dropdown
                el-dropdown-menu
                  el-dropdown-item
                    span(@click="desconectarCliente(cliente.clientId)").moduloAcao
                      i.far.fa-power-off(:style="{'font-size': '20px', 'margin-right': '8px'}")
                      p Desconectar
        .linha
        div.infoModulos
          p
            strong.dado Client ID:
            span {{ encurtarString(cliente.clientId.length, 15, cliente.clientId) }}
          p
            strong.dado Status:
            span Ativo
        div.qrCodeContainer
          el-image(v-if="cliente.qrCode" :src="cliente.qrCode" fit="contain" :style="{'width': '200px', 'height': '200px'}")
          div(v-else).conatinerClienteConectado
            span Cliente conectado!

    div.formOptionContainer
      el-radio-group(v-model="selectedAction")
        el-radio-button(label="Disparar mensagem de teste")
        el-radio-button(label="Criar disparo em massa")

    div.messageFormContainer(v-if="selectedAction === 'Disparar mensagem de teste'")
      el-form(ref="messageForm", :model="messageForm", :rules="rules" label-width="120px" label-position="top")
        el-row(:gutter="20")
          el-col(:span="12")
            el-form-item(label="Selecione o Cliente" prop="clientId")
              el-select(v-model="messageForm.clientId" placeholder="Selecione um cliente")
                el-option(v-for="cliente in clientes" :key="cliente.clientId" :label="cliente.clientId" :value="cliente.clientId")
          el-col(:span="12")
            el-form-item(label="Número" prop="numero")
              el-input(v-model="messageForm.numero" placeholder="Insira o número do destinatário")
        el-form-item(label="Mensagem" prop="mensagem")
          el-input(type="textarea", v-model="messageForm.mensagem", :rows="5" placeholder="Insira a mensagem")
        el-form-item
          el-button(type="primary", @click="enviarMensagem") Enviar Mensagem

    div.uploadContainer(v-if="selectedAction === 'Criar disparo em massa'")
      div.statusContainer
        el-row(:gutter="20")
          el-col(:span="8")
            div.container-card
              div
                span.bold Total de Mensagens
              div.container-totalizador
                span.quantidade {{statusDisparo.totalPendente + statusDisparo.totalDisparado}}
                i.el-icon-chat-dot-round
          el-col(:span="8")
            div.container-card
                div
                  span.bold Total pendente
                div.container-totalizador
                  span.quantidade {{statusDisparo.totalPendente}}
                  i.el-icon-question
          el-col(:span="8")
            div.container-card
              div
                span.bold Total disparado
              div.container-totalizador
                span.quantidade {{statusDisparo.totalDisparado}}
                i.el-icon-arrow-down

      div.filter
        el-card.filter(shadow="never")
          p.title Filtros
            el-form(ref="filter" :model="filter" label-width="120px" label-position="top")
              el-row(:gutter="20")
                el-col(:span="6")
                  el-form-item(label="Nome do interessado:" prop="nomeInteressado")
                    el-input(v-model="filter.nomeInteressado" placeholder="Digite aqui...")
                el-col(:span="6")
                  el-form-item(label="CPF/CNPJ do interessado:", prop="cpfCnpjInteressado")
                    el-input(v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="filter.cpfCnpjInteressado" placeholder="000.000.000-00")
                el-col(:span="6")
                  el-form-item(label="Número do processo:" prop="numeroProcesso")
                    el-input(v-model="filter.numeroProcesso" placeholder="Digite aqui...")
                el-col(:span="6")
                  el-form-item(label="Tipo do processo:" prop="tipoProcesso")
                    el-select.select(placeholder="Selecione", v-model="filter.tipoProcesso" clearable)
                      el-option(v-for="tipo in tiposProcessos" :key="tipo.codigo" :label="tipo.nome" :value="tipo.codigo")
              el-row(:gutter="20")
                el-col(:span="6")
                  el-form-item(label="Município:" prop="municipio")
                    el-select.select(placeholder="Selecione", v-model="filter.municipio" filterable clearable)
                      el-option(v-for="m in municipios" :key="m.id" :label="m.nome" :value="m.id")
                el-col(:span="6")
                  el-form-item(label="Endereço:", prop="endereço")
                    el-input(v-model="filter.endereço" placeholder="Digite aqui...")
                el-col(:span="6")
                  el-form-item(label="Bairro:" prop="bairro")
                    el-input(v-model="filter.bairro" placeholder="Digite aqui...")
                el-col(:span="6")
                  el-form-item(label="Lote:" prop="lote")
                    el-input(v-model="filter.lote" placeholder="Digite aqui...")
              el-row(:gutter="20")
                el-col(:span="6")
                  el-form-item(label="Quadra:" prop="quadra")
                    el-input(v-model="filter.quadra" placeholder="Digite aqui...")
                el-col(:span="6")
                  el-form-item(label="Período de cadastro:", prop="periodoCadastro")
                    el-date-picker(
                      v-model="filter.periodoCadastro"
                      type="daterange"
                      align="left"
                      format="dd/MM/yyyy"
                      start-placeholder="Data inicial"
                      end-placeholder="Data final")
              el-row(:gutter="10")
                div.row
                  span(@click="exibirBuscaPorLote")
                    p.busca Pesquisa por lote
                  el-tooltip(
                    effect='dark',
                    placement="top-end"
                  )
                    i.el-icon-info.icon-info
                    template(slot="content") Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
                      a.btn-download(@click="baixarModelo") (Baixar modelo)
                div(v-if="showPesquisaLote")
                  app-upload-area.container-app-upload(
                    v-if="showPesquisaLote",
                    id="lote",
                    :target="'publico/upload'"
                    :fileType="validExtensions"
                    :onSuccess="onSuccessPesquisaLote"
                    :documento="filePesquisaLote"
                    :hasDownloadButton="false",
                    v-model="filePesquisaLote"
                    @removerDocumento="removerDocumentoPesquisaLote"
                  )
              el-form-item
                div.containerBotaoDireita
                  el-button(type="secondary", @click="limparFiltro") limpar
                  el-button(type="primary", @click="() => buscarProcessos(false)") Pesquisar

      app-listagem.tabela(
        :has-refresh-button="true",
        :json-headers="colunas",
        :json-data="itens",
        :pagina="filtro.pagina",
        :hasFiltroRapido="false",
        :filtro="filtro",
        :totalElements="totalElements",
        @sort="sort",
        @updateListagem="buscarProcessos",
        @changePage="changePage",
      )

      div.containerBotaoDireita
        el-button(type="primary", @click="abrir") Criar mensagem

      app-modal.modalFaleConosco(
        v-if="showModal",
        :titulo="'Criar mensagem'",
        @closeModal="closeModal",
        :width="1300",
        :bodyStyle="{height: 'auto'}",
        :footerStyle="{display: 'flex', justifyContent: 'right'}",
        :responsive="false"
      )
        template(slot="body")
          p.title Para personalizar sua mensagem, use as seguintes variáveis
          el-card.variable(shadow="never")
            p(v-pre) {{numero_processo}} > substitui o número do processo
            p(v-pre) {{nome_interessado}} > substitui o nome do interessado
          el-form(ref="massMessageForm", :model="massMessageForm", :rules="massRules" label-width="120px" label-position="top")
            el-row(:gutter="20")
              el-col(:span="24")
                el-form-item.title(label="Mensagem" prop="massMensagem")
                  el-input(type="textarea", v-model="massMessageForm.massMensagem", :rows="5" placeholder="Insira a mensagem")
                small.counter Caracteres {{massMessageForm.massMensagem.length}}/500
            el-row(:gutter="20")
              el-col(:span="24")
                el-form-item.title(label="Selecione o arquivo de imagem:" prop="imagem")
                  app-upload-area(
                    id="imagem-whatsapp",
                    :target="'publico/upload'"
                    :fileType="validExtensionsImagem"
                    :onSuccess="onSuccessImagem"
                    :documento="imagem"
                    :hasDownloadButton="false",
                    v-model="imagem"
                    @removerDocumento="removerImagem"
                    :maxSize="4"
                  )

        template(slot="footer")
          div.buttons
            el-button.cancelarButton(@click="fecharModalMensagem")
              i.fas.fa-times
              |  Cancelar
            el-button(type="primary",key="botao-confirma",@click="confirmacaoDisparoEmMassa")
              i.fas.fa-check
              |  Disparar mensagem
</template>

<script>
import { registerClient, getClients, disconnectClient, sendMessage, programarMensagens, getStatusDisparo, getProcessos } from '../../../utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppListagem from '@/components/AppListagem.vue'
import AppModal from '@/components/AppModal'
import AppUploadArea from '@/components/AppUploadArea'
import FILTRO_EMPTY from '../../../models/filtro'
import { mapActions } from 'vuex'
const { tiposProcessos } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppUploadArea,
    AppListagem,
    AppModal
  },
  data () {
    return {
      showPesquisaLote: false,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', sortable: true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Interessado', propriedade: 'nomeInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 3, titulo: 'Tipo de processo', propriedade: 'tipoProcesso', ordem: 3, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'nomeMunicipio', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Bairro', propriedade: 'nomeBairro', ordem: 5, acoes: [] }
      ],
      clientes: [],
      statusDisparo: {
        totalPendente: 0,
        totalDisparado: 0
      },
      variavis: [
        { nome: '{{numero_processo}}', descricao: 'Número do processo' },
        { nome: '{{nome_interessado}}', descricao: 'Nome do interessado' }
      ],
      selectedAction: 'Disparar mensagem de teste',
      validExtensions: ['xlsx', 'xls', 'csv'],
      validExtensionsImagem: ['jpg', 'jpeg', 'png'],
      filePesquisaLote: null,
      file: null,
      imagem: null,
      messageForm: {
        clientId: '',
        numero: '',
        mensagem: ''
      },
      municipios: [],
      itens: [],
      pagina: 0,
      totalElements: 0,
      filter: {
        nomeInteressado: null,
        cpfCnpjInteressado: null,
        numeroProcesso: null,
        tipoProcesso: null,
        municipio: null,
        endereco: null,
        bairro: null,
        lote: null,
        quadra: null,
        periodoCadastro: null,
        nomePlanilha: null
      },
      rules: {
        clientId: [{ required: true, message: 'Selecione um cliente', trigger: 'change' }],
        numero: [{ required: true, message: 'Insira o número do destinatário', trigger: 'blur' }],
        mensagem: [{ required: true, message: 'Insira a mensagem', trigger: 'blur' }]
      },
      filtro: FILTRO_EMPTY('WAP_DISPARO_MASSA'),
      massMessageForm: {
        massMensagem: ''
      },
      massRules: {
        massMensagem: [{ required: true, message: 'Insira a mensagem', trigger: 'blur' }]
      },
      showModal: false
    }
  },

  async created () {
    this.findMunicipiosByUf()
    await this.buscarTodosClientes()
    await this.atualizarStatusDisparo()
    setInterval(this.buscarTodosClientes, 30000)
  },
  mixins: [AppNotificacao],
  computed: {
    tiposProcessos () {
      return tiposProcessos
    },
    checkFilter () {
      return Object.values(this.filter).every(value => value === null)
    }
  },
  methods: {
    ...mapActions({
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'
    }),

    limparFiltro () {
      const filtroEmpty = {
        nomeInteressado: null,
        cpfCnpjInteressado: null,
        numeroProcesso: null,
        tipoProcesso: null,
        municipio: null,
        endereco: null,
        bairro: null,
        lote: null,
        quadra: null,
        periodoCadastro: null,
        nomePlanilha: null
      }
      this.filter = filtroEmpty
      this.buscarProcessos()
      this.removerDocumentoPesquisaLote()
      this.showPesquisaLote = false
    },

    fecharModalMensagem () {
      this.closeModal()
      this.massMessageForm.massMensagem = ''
      this.removerImagem()
    },
    async atualizarStatusDisparo () {
      try {
        const status = await getStatusDisparo()
        this.statusDisparo.totalPendente = status.totalPendente
        this.statusDisparo.totalDisparado = status.totalDisparado
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar status de disparo')
      }
    },
    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
    },
    onSuccess (id, resumableFile, fileKey) {
      this.massMessageForm.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
    },

    baixarModelo () {
      this.getModeloRelatorio()
    },
    onSuccessImagem (id, resumableFile, fileKey) {
      this.imagem = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
    },

    onSuccessPesquisaLote (id, resumableFile, fileKey) {
      this.filePesquisaLote = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filter.nomePlanilha = this.filePesquisaLote.fileKey
    },

    removerDocumentoPesquisaLote () {
      this.filePesquisaLote = null
      this.filter.nomePlanilha = null
    },

    removerDocumento () {
      this.massMessageForm.file = null
    },

    removerImagem () {
      this.imagem = null
    },
    sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      this.buscarProcessos()
    },
    async buscarProcessos (isChangePage) {
      try {
        if (!isChangePage) this.pagina = 0
        const resposta = await getProcessos(this.pagina, this.filtro, this.filter)
        this.itens = resposta.content
        this.totalElements = resposta.totalElements
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar processos')
      }
    },
    async changePage (newValue) {
      this.pagina = newValue - 1
      await this.buscarProcessos(true)
    },
    async buscarTodosClientes () {
      try {
        const resposta = await getClients()
        this.clientes = resposta
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar clientes')
      }
    },
    async registrarCliente () {
      try {
        const resposta = await registerClient()
        if (resposta) {
          this.buscarTodosClientes()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Cliente registrado com sucesso')
        }
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao registrar cliente')
      }
    },
    async desconectarCliente (clientId) {
      this.confirmBox('Deseja realmente desconectar este cliente?', 'Atenção',
        async () => {
          try {
            await disconnectClient(clientId)
            this.clientes = this.clientes.filter(cliente => cliente.clientId !== clientId)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Cliente desconectado com sucesso')
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao desconectar cliente')
          }
        }
      )
    },
    async enviarMensagem () {
      this.$refs.messageForm.validate(async (valid) => {
        if (valid) {
          try {
            const numeroLimpo = this.messageForm.numero.replace(/\D/g, '')
            await sendMessage(numeroLimpo, this.messageForm.mensagem, this.messageForm.clientId)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Mensagem enviada com sucesso')
            this.messageForm.numero = ''
            this.messageForm.mensagem = ''
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao enviar mensagem')
          }
        } else {
          console.log('Erro na validação do formulário')
          return false
        }
      })
    },
    confirmacaoDisparoEmMassa () {
      this.$refs['massMessageForm'].validate(async (valid) => {
        if (valid) {
          this.confirmBox(`Você está prestes a enviar a mensagem para ${this.totalElements} interessados. deseja continuar?`, 'Atenção', () => {
            this.criarDisparoMassa()
          })
        } else {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Preencha todos os campos')
        }
      })
    },

    async criarDisparoMassa () {
      try {
        const processos = this.itens.map(processo => processo.numeroProcesso)
        await programarMensagens({ template: this.massMessageForm.massMensagem, key: this.massMessageForm?.file?.fileKey, keyImagem: this.imagem?.fileKey, processos }, this.filter)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Disparo em massa criado com sucesso')
        this.massMessageForm.massMensagem = ''
        this.removerDocumento()
        this.atualizarStatusDisparo()
        this.removerImagem()
        this.closeModal()
      } catch (e) {
        console.log(e)
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao criar disparo em massa')
      }
    },
    encurtarString (tamanho, limite, texto) {
      return tamanho >= limite ? texto.substring(0, limite) + '...' : texto
    },
    async findMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, 'PA')
    },
    abrir () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style scoped>
  .box {
    min-width: 700px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .el-icon-arrow-down, .el-icon-chat-dot-round, .el-icon-question {
    font-size: 40px;
    color: #009F61;
  }
  .container-card {
    width: 100%;
    border:solid 2px #009F61;
    height: 100px;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .container-totalizador {
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
  .quantidade {
    font-weight: bold;
    font-size: 24px;
  }
  .bold {
    font-size: 16px;
    font-weight: bold;
  }
  .nomeModuloContainer {
    height: 35px;
    align-items: center;
  }
  .infoModulos {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
  }
  .botao {
    width: 120px;
    height: 40px;
    font-size: 15px;
  }
  .botaoModulo {
    display: flex;
    justify-content: space-between;
  }
  .botaoAdd {
    font-size: 18px;
    align-items: end;
  }
  .containerBotao {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
  }
  .modulosContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;
  }
  .modulo {
    border: 1px solid rgba(0, 0, 0, 0.10);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
    border-radius: 5px;
    width: 380px;
    height: 350px;
    padding: 10px;
    margin: 0px 60px 60px 0px;
  }
  .vistoPorUltimo {
    text-align: start;
    font-size: 10px
  }
  p {
    font-size: 15px ;
    margin-right: 1px;
  }

  .dado {
    margin-right: 5px;
  }

  .titulo {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
  }
  .icon-info {
    font-size: 25;
    margin: 0 0 10px 5px;
  }
  .moduloAcao {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    width: 110px;
    margin: 0;
  }
  .linha {
    background-color: rgba(0, 0, 0, 0.10);
    margin-top: 10px;
    margin-bottom: 2px;
    width: 100%;
    height: 2px;
  }
  .qrCodeContainer {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .conatinerClienteConectado {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
    background-color: #ffffff; /* Fundo branco */
    border-radius: 5px;
    border: 2px solid rgb(86, 242, 86); /* Borda verde neon */
    color: rgb(86, 242, 86); /* Texto verde neon */
    font-weight: bold;
  }
  .messageFormContainer {
    margin-top: 50px;
    padding: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
  }
  .container-app-upload {
    padding-bottom: 10px;
  }
  .busca {
    padding: 12px 0 8px 0px;
    text-align: left;
    color: #009F61 !important;
    cursor: pointer;
    &:hover {
      font-weight: bold;
    }
  }
  .formOptionContainer {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .statusContainer {
    margin-bottom: 20px;
  }
  .containerBotaoDireita{
    display: flex;
    justify-content: flex-end;
  }
  .select {
    width: 100%;
  }
  .variable {
    margin-bottom: 20px;
    background-color: #f0f0f0;
  }
  .buttons {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .counter {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .totalCard, .pendenteCard, .disparadoCard {
    text-align: center;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .row {
    margin-left: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/pa/WapClientsPa.vue